module.exports = __webpack_public_path__ + "assets/img/simply-Brand_06.93082b3a.png";